import { getShipName } from 'app/utils/utils';
import { Link } from 'react-router-dom';
import { OwnedTargetInfo, SnapshotData } from 'ais-facade-api/api';
import { useAddToFleetMutation } from 'app/api/fleet';
import { useAppSelector } from 'app/store/store';
import { Icon } from '../Icon/Icon';
import { useTranslation } from 'react-i18next';
import { useEffect, useState } from 'react';
import { Button } from '../Button';

import styles from './AtonCard.module.scss';

interface AtonCardHeaderI {
  onClose: () => void;
  atonInfo?: OwnedTargetInfo | SnapshotData;
  refetchFunc: () => void;
}

export const AtonCardHeader = ({ onClose, atonInfo, refetchFunc }: AtonCardHeaderI) => {
  const { t } = useTranslation();

  if (!atonInfo) {
    return null;
  }

  const user = useAppSelector((state) => state.userSlice.user);
  const [addToFleet] = useAddToFleetMutation();

  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    setIsLoading(false);
  }, [atonInfo]);

  function handleAddToFleet() {
    const user_id = user?.value.sub;

    if (user_id && typeof atonInfo?.mmsi === 'number') {
      setIsLoading(true);
      addToFleet({ mmsiArray: [atonInfo.mmsi] })
        .unwrap()
        .then(() => {
          setIsLoading(false);
          refetchFunc();
        })
        .catch(() => {
          setIsLoading(false);
        })
        .finally(() => {
          setIsLoading(!atonInfo.belongsToFleet);
        });
    }
  }

  return (
    <div className={styles.header_wrapper}>
      <div className={styles.header}>
        <div className={styles.ship_type_icon}>
          <Icon name="aton" size="16" />
        </div>
        <div className={styles.name}>{getShipName(atonInfo)}</div>
        <div onClick={onClose}>
          <Icon name="close-16" size="16px" />
        </div>
      </div>

      <div className={styles.sub_header}>
        <div className={styles.type}> {t('Aton')} </div>

        {'belongsToFleet' in atonInfo &&
          (atonInfo.belongsToFleet ? (
            <Link className={styles.fleet} to="/fleet">
              <Icon name="my-fleet" width="13px" height="12px" />
              {t('FleetLabel')}
            </Link>
          ) : (
            <Button onClick={handleAddToFleet} disabled={isLoading} variant="ghost">
              <Icon name="add" size="14px" />
              {t('FleetLabel')}
            </Button>
          ))}
      </div>
    </div>
  );
};
